import * as angular from "angular";
import {IController} from "angular";
import {ServiceAreasServiceType} from "../../../service-areas/angular/types/service-areas-service.type";

export class bringozSelectFilterPanelCtrl implements IController {

  type: any;
  panelRef: any;
  selectedId: any;
  accountIds: string[];
  options?: any;
  optionsWrapper?: { list?: any[], propertyRef: string };
  branchIds: any;
  resourceIds: any;
  serviceAreaIds: any;
  serviceAreasTypes: ServiceAreasServiceType[];
  ngPlaceholder: any;
  noUnderline: any;
  excludeIds: any;
  optionsPrefix: string;
  selectParams: any;
  isHideResetButton: boolean;
  selectedIds: string[];

  private selectedIdCopy: any;

  $onInit() {
    if (this.selectedId !== undefined) {
      this.selectedIdCopy = angular.copy(this.selectedId);
    }
  }

  onSelectValue(id, selectedItem?) {
    this.selectedIdCopy = id;
    this.panelRef.config.onCloseSuccess(this.panelRef, this.selectedIdCopy, selectedItem);
  }

  onReset() {
    this.panelRef.config.onCloseSuccess(this.panelRef, undefined);
  }

}

angular
  .module('bringoz.admin.commons')
  .component('bringozSelectFilterPanel', {
    bindings: {
      type: '<',
      queryMap: '<?', // a map of queries useful for filters (like branchIds/carrierIds/serviceAreasTypes etc..)
      panelRef: '<',
      selectedId: '<?',
      options: '<?',
      optionsWrapper: '<?',
      optionIds: '<?',
      optionsPrefix: '@?',
      accountIds: '<?',
      ngPlaceholder: '<?',
      excludeIds: '<?',
      selectedIds: '<?',
      branchIds: '<?',
      depotIds: '<?',
      pageName: '<?',
      serviceAreasTypes: '<?',
      selectParams: '<?',
      isHideResetButton: '<?'
    },
    template: require('./bringoz-select-filter-panel.html').default,
    controller: bringozSelectFilterPanelCtrl
  });
